import { FaroCoreApiConst } from "@stellar/core-api-client";

/** Determines whether the member is in type of company */
export function isCompanyMember(member) {
  return "role" in member && isCompanyRole(member.role) && !("dateJoined" in member) && !isLoggedInUser(member);
}

/**
 * Determines whether the member is for company base or not
 * Based on the definition of sdbTeamMemberBase, it will also be returned as true
 */
export function isCompanyMemberBase(member) {
  return isCompanyMember(member) && !("userRole" in member) && !isLoggedInUser(member);
}

/** Determine whether the type of member is from company with details or not */
export function isCompanyMemberDetails(member) {
  return isCompanyMember(member) && "userRole" in member && isCompanyRole(member.userRole) && !isLoggedInUser(member);
}

/** Determines whether the member is for projects or not */
export function isProjectMemberBase(member) {
  return "role" in member && isProjectRole(member.role) && !isLoggedInUser(member);
}

/** Determines whether the member is in type of group */
export function isGroupMember(member) {
  return typeof member === "object" && member !== null && "role" in member &&
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- allows role inputs
  isCompanyRole(member.role) && !("userRole" in member) && "dateJoined" in member;
}

/** Returns whether the member type is in type of UserDetails */
export function isUserDetails(user) {
  return "haveCamera" in user && "howFound" in user && "profileImageUrl" in user;
}

/** Determines whether the member type is from user as manager or not */
export function isUserAsManager(member) {
  return !("role" in member) && !isUserDetails(member) && !isLoggedInUser(member);
}

/** Whether the member is loggedInUser or not */
export function isLoggedInUser(user) {
  return "authenticationInfo" in user;
}

/** Determines whether the role is related to company or not */
export function isCompanyRole(role) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- allows AllCompanyRoles inputs
  return FaroCoreApiConst.allCompanyRoles.includes(role);
}

/** Determines whether the role is related to project or not */
export function isProjectRole(role) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- allows AllProjectRoles inputs
  return FaroCoreApiConst.allProjectRoles.includes(role);
}

// TODO: ST-646 Add new group viewer role: https://faro01.atlassian.net/browse/ST-3056
/** Determines whether the role is related to group or not */
export function isGroupRole(role) {
  return ["COMPANY_MANAGER", "GROUP_VIEWER", "PROJECT_MANAGER"].includes(role);
}